import { render, staticRenderFns } from "./creatingroles.vue?vue&type=template&id=945277c0&scoped=true&"
import script from "./creatingroles.vue?vue&type=script&lang=js&"
export * from "./creatingroles.vue?vue&type=script&lang=js&"
import style0 from "./creatingroles.vue?vue&type=style&index=0&id=945277c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945277c0",
  null
  
)

export default component.exports